import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/download/Home.vue'
import DownloadH5 from './views/download/DownloadH5.vue';
import InvitationPage from './views/invitation/index.vue';

const AgentInfo = navigator.userAgent;
const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];

let ifPC = true;
Agents.forEach(item => {
  if (AgentInfo.indexOf(item) !== -1) {
    ifPC = false;
  }
})

Vue.ifPC = ifPC;

Vue.use(Router);

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home',
    component: ifPC ? Home : DownloadH5
  }, {
    path: '/invitation',
    name: '注册邀请',
    component: InvitationPage
  }]
})